import { Box, SimpleGrid, Group, Image, Text, rem, Card } from "@mantine/core";
import { getFDTLabelImageName, getFDTLabelNamesForTestType } from "@utils/UIUtils";
import { useTranslation } from "react-i18next";
import { TestType } from "types/testTypes";

interface FDTSymbolsLegendProps {
  testType: TestType;
  cols?: number;
  spacing?: string;
  larger?: boolean;
}

export default function FDTSymbolsLegend(props: FDTSymbolsLegendProps) {
  const { testType, spacing, cols, larger } = props;
  const { t } = useTranslation();
  const labelHumanReadable = {
    P_GTE_1: "P >= 1%",
    P_LT_1: "P < 1%",
    P_LT_0_5: "P < 0.5%",
    P_GTE_5: "P >= 5%",
    P_LT_5: "P < 5%",
    P_LT_2: "P < 2%",
    MAX: t("notSeenAtMaximum"),
  };

  const labelImages = getFDTLabelNamesForTestType(testType);

  return (
    <Box {...props}>
      <Card>
        <SimpleGrid cols={cols ?? 1} spacing={spacing}>
          {labelImages.map((imageKey, index) => {
            return (
              <Group gap={"sm"} wrap="nowrap" key={"fdt-legend-" + index}>
                <Box w={rem(larger ? 45 : 30)} style={{ aspectRatio: 1 }}>
                  <Image
                    src={`img/fdt-img/${getFDTLabelImageName(testType, imageKey)}.png`}
                    style={{ border: "1px solid var(--oculera-border)" }}
                  />
                </Box>
                <Text fz={larger ? "lg" : "md"} fw={600}>
                  {labelHumanReadable[imageKey]}
                </Text>
              </Group>
            );
          })}
        </SimpleGrid>
      </Card>
    </Box>
  );
}
